export default "__VITE_ASSET__nZH836CA__"